const TENANT_MANAGEMENT = "/tenantManagement";
const USER_MANAGEMENT = "/userManagement";
const RBAC_MANAGEMENT = "/rbacManagement";
const CREATE_USER = "/createUser";
const RESOURCE_MANAGER_HOME = "/resourceManager";
const PUBLIC_RESOURCE_MANAGER_HOME = "/publicResourceManager";
const PUBLIC_RESOURCE_MANAGE_VM = "/publicResourceManageVM";
const CLOUD_PROVIDER_AZURE_LIST = "/cloudProviderAzure";
const RESOURCE_PROVIDER = "/resourceProvider";
const PUBLIC_RESOURCE_PROVIDER = "/publicResourceProvider";
const CREATE_TEMPLATE = "/createTemplate";
const EDIT_TEMPLATE = "/editTemplate";
const PUBLIC_CREATE_TEMPLATE = "/publicCreateTemplate";
const PUBLIC_CREATE_AZURE_VM_TEMPLATE = "/publicCreateAzureVmTemplate";
const PUBLIC_EDIT_TEMPLATE = "/publicEditTemplate";
const TEMPLATE_HOME = "/templateHome";
const PUBLIC_TEMPLATE_HOME = "/publicTemplateHome";
const CREATE_CATALOGUE = "/createCatalogue";
const MACHINE_CATALOGUE = "/machineCatalogue";
const MY_LABS = "/myLabs";
const MANAGE_VM = "/manageVm";
const SKU_MANAGE = "/sku_manage";
const MANAGE_INSTANCE_SIZE = "/manageInstanceSize";
const USER_MACHINE_CATALOG = "/userMachineCatalog";
const CREDIT_BASED_LAB_DETAILS = "/creditBasedLabDetails";
const NOTIFICATION_MANAGEMENT = "/notificationManagement";
const REQUEST_MANAGER = "/requestManager";
const TENANT_DETAILS_ERROR = "/tenantDetailsError";
const DASHBOARD = "/dashboard";
const ACTIONLOG = "/actionLog";
const NOTIFICATIONS = "/notifications";
const NOTIFICATION_SETTINGS = "/notificationSettings";
const USAGE = "/usage";
const WORKSPACE = "/workspace";
const PAGE_NOT_FOUND = "/pageNotFound";
const Profile = "/profile";
const USER_WORKSPACE = "/wsUserWorkspace";
const USER_WORKSPACE_DASHBOARD = "/userWorkspaceDashboard";
const API_HELP = "/apiDocumentation";
const API_SERVICES_DOCS = `/v1/:service/doc`;
const LOGIN = `/login`;
const WSM_LOGIN = `/wsmLogin`;
const REPORT_ENGINE = "/report";
const VM_CONNECT = "/vm-connect";
const B2C_LABS = "/b2cLabs";
const B2C_PLANS = "/b2cPlan";
const VM_INSIGHT = "/vm-insight";
const VM_INSIGHT_DETAILS = "/vm-insight-details";
const TENANT_CATALOGUE = "/tenantCatalogue";
const INVOICES = "/invoices";
const B2C_PAYMENT = "/lab-purchase";
const B2C_INVOICE = "/lab-invoice";
const B2C_DASHBOARD = "/b2c-dashboard"; // For development purpose
// const MY_LABS_B2C = "/mylabsB2C"
const RESELLERLICENSE = "/LicenceList";
const CREATRESELLERLICENSE = "/CreateLicense";
const RESELLERLICENSE_CLIENT_VIEW = "/ResellerLicenceClientView";
const VM_DASHBOARD_INFO = "/Dashboard-vm";
const AZURE_DASHBOARD_INFO = "/Dashboard-cloud";
const VM_USAGE_AND_BILLING = "/vmUsageAndBilling";
const CLOUD_LABS_MONITOR = "/cloud-labs-monitor";

export const ROUTES = {
  ROOT: "/",
  DASHBOARD: DASHBOARD,
  TENANT_MANAGEMENT: TENANT_MANAGEMENT,
  RESELLERLICENSE: `${RESELLERLICENSE}`,
  CREATRESELLERLICENSE: CREATRESELLERLICENSE,
  EDIT_RESELLERLICENSE: `${RESELLERLICENSE}/editLicense`,
  RESELLERLICENSE_CLIENT_VIEW: `${RESELLERLICENSE_CLIENT_VIEW}`,
  ADD_TENANT: `${TENANT_MANAGEMENT}/createTenant`,
  EDIT_TENANT: `${TENANT_MANAGEMENT}/editTenant`,
  USER_MANAGEMENT: `${TENANT_MANAGEMENT}${USER_MANAGEMENT}`,
  RBAC_MANAGE_HOME: `${TENANT_MANAGEMENT}${RBAC_MANAGEMENT}`,
  RBAC_FEATURE_POLICY: `${TENANT_MANAGEMENT}${RBAC_MANAGEMENT}/rolePermissions/`,
  VIEW_USER_DETAILS: `${TENANT_MANAGEMENT}${USER_MANAGEMENT}/userDetails/`,
  EDIT_USER: `${TENANT_MANAGEMENT}${USER_MANAGEMENT}/editUser/`,
  ADD_USER: `${TENANT_MANAGEMENT}${USER_MANAGEMENT}${CREATE_USER}`,
  TENANT_VIEW_DETAILS: `${TENANT_MANAGEMENT}/tenantDetails/`,
  RESOURCE_PROVIDER_HOME: `${RESOURCE_MANAGER_HOME}${RESOURCE_PROVIDER}`,
  PUBLIC_RESOURCE_PROVIDER_HOME: `${PUBLIC_RESOURCE_MANAGER_HOME}${PUBLIC_RESOURCE_MANAGE_VM}`,
  PUBLIC_RESOURCE_MANAGE_VM: `${PUBLIC_RESOURCE_MANAGE_VM}`,
  CLOUD_PROVIDER_AZURE_LIST: `${CLOUD_PROVIDER_AZURE_LIST}`,
  ADD_RESOURCE: `${RESOURCE_MANAGER_HOME}${RESOURCE_PROVIDER}/addResource`,
  PUBLIC_ADD_RESOURCE: `${RESOURCE_MANAGER_HOME}${PUBLIC_RESOURCE_PROVIDER}/addResource`,
  EDIT_RESOURCE: `${RESOURCE_MANAGER_HOME}${RESOURCE_PROVIDER}/editResource`,
  PUBLIC_EDIT_RESOURCE: `${RESOURCE_MANAGER_HOME}${PUBLIC_RESOURCE_PROVIDER}/editResource`,
  ACCOUNT_DETAILS_RESOURCE: `${RESOURCE_MANAGER_HOME}/accountDetails`,
  CREATE_TEMPLATE: `${RESOURCE_MANAGER_HOME}${CREATE_TEMPLATE}`,
  EDIT_TEMPLATE: `${RESOURCE_MANAGER_HOME}${EDIT_TEMPLATE}`,
  PUBLIC_CREATE_TEMPLATE: `${RESOURCE_MANAGER_HOME}${PUBLIC_CREATE_TEMPLATE}`,
  PUBLIC_CREATE_AZURE_VM_TEMPLATE: `${RESOURCE_MANAGER_HOME}${PUBLIC_CREATE_AZURE_VM_TEMPLATE}`,
  PUBLIC_EDIT_TEMPLATE: `${RESOURCE_MANAGER_HOME}${PUBLIC_EDIT_TEMPLATE}`,
  TEMPLATE_CREATION_HOME: `${RESOURCE_MANAGER_HOME}${TEMPLATE_HOME}/`,
  PUBLIC_TEMPLATE_CREATION_HOME: `${RESOURCE_MANAGER_HOME}${PUBLIC_TEMPLATE_HOME}/`,
  CREATE_CATALOGUE: `${CREATE_CATALOGUE}`,
  MACHINE_CATALOGUE: `${MACHINE_CATALOGUE}`,
  MY_LABS: `${MY_LABS}`,
  MANAGE_VM: `${MANAGE_VM}`,
  SKU_MANAGE: `${SKU_MANAGE}`,
  MANAGE_INSTANCE_SIZE: `${RESOURCE_MANAGER_HOME}${MANAGE_INSTANCE_SIZE}`,
  USER_MACHINE_CATALOG: `${USER_MACHINE_CATALOG}`,
  PRICE: `${TENANT_MANAGEMENT}/priceSummery/`,
  NOTIFICATION_MANAGEMENT: `${NOTIFICATION_MANAGEMENT}`,
  NOTIFICATION_SETTINGS: `${NOTIFICATION_SETTINGS}`,
  REQUEST_MANAGER: REQUEST_MANAGER,
  TENANT_DETAILS_ERROR: TENANT_DETAILS_ERROR,
  ACTION_LOG: ACTIONLOG,
  NOTIFICATIONS: NOTIFICATIONS,
  USAGE: USAGE,
  PAGE_NOT_FOUND: PAGE_NOT_FOUND,
  WORKSPACE_MANAGER: WORKSPACE,
  PROFILE: Profile,
  CREATE_WORKSPACE: `${WORKSPACE}/createWorkspace`,
  EDIT_WORKSPACE: `${WORKSPACE}/editWorkspace`,
  USER_WORKSPACE: `${USER_WORKSPACE}`,
  USER_WORKSPACE_DASHBOARD: `${USER_WORKSPACE_DASHBOARD}`,
  API_HELP: API_HELP,
  API_SERVICES_DOCS: API_SERVICES_DOCS,
  PUBLIC_LAB_DETAILS: `${MACHINE_CATALOGUE}/publicLabDetails`,
  TENANT_ADMIN_PUBLIC_LAB_DETAILS: `${USER_MACHINE_CATALOG}/publicLabDetails`,
  BATCH_DETAILS: `${MACHINE_CATALOGUE}/publicLabDetails/batchDetails`,
  WORKSPACE_BATCH_DETAILS: `${MACHINE_CATALOGUE}/publicLabDetails/workspaceBatchDetails`,
  ADD_BATCH: `${MACHINE_CATALOGUE}/addbatch`,
  EDIT_BATCH: `${MACHINE_CATALOGUE}/editbatch`,
  ADD_LAB: `${MACHINE_CATALOGUE}/addLab`,
  WORKSPACE_BATCH_DETAILS_USERS: `${MACHINE_CATALOGUE}/WorkspaceBatchDetailsUser`,
  ADD_WORKSPACE_BATCH: `${MACHINE_CATALOGUE}/addWorkspaceBatch`,
  EDIT_WORKSPACE_BATCH: `${MACHINE_CATALOGUE}/editWorkspaceBatch`,
  ADD_WORKSPACE_LAB: `${MACHINE_CATALOGUE}/addWorksapceLab`,
  CREDIT_BASED_LAB_DETAILS: CREDIT_BASED_LAB_DETAILS,
  LOGIN: LOGIN,
  WSM_LOGIN: WSM_LOGIN,
  REPORT_ENGINE: REPORT_ENGINE,
  CUSTOM_REPORT: `${REPORT_ENGINE}/customReport`,
  VM_CONNECT: VM_CONNECT,
  B2C_LABS: B2C_LABS,
  B2C_PLANS: B2C_PLANS,
  VM_INSIGHT: VM_INSIGHT,
  VM_INSIGHT_DETAILS: VM_INSIGHT_DETAILS,
  TENANT_CATALOGUE: TENANT_CATALOGUE,
  INVOICES: INVOICES,
  B2C_PAYMENT: B2C_PAYMENT,
  B2C_INVOICE: B2C_INVOICE,
  B2C_DASHBOARD: B2C_DASHBOARD, // For development purpose
  // MY_LABS_B2C: MY_LABS_B2C,
  VM_DASHBOARD_INFO: VM_DASHBOARD_INFO,
  AZURE_DASHBOARD_INFO: AZURE_DASHBOARD_INFO,
  PUBLIC_AZURE_SKU_LIST: `${RESOURCE_MANAGER_HOME}/publicAzureSkuList`,
  VM_USAGE_AND_BILLING: VM_USAGE_AND_BILLING,
  CLOUD_LABS_MONITOR: CLOUD_LABS_MONITOR,
  CLOUD_LABS_DASHBOARD: `${CLOUD_LABS_MONITOR}/dashboard`,
  CLOUD_LABS_LAB_DETAIL: `${CLOUD_LABS_MONITOR}/lab`,
};
